import { ReportePagosNominasPreviredDto, TrabajadorCasaParticularDto } from '../reportes-api.services';

export interface InstitucionPrevired {
    institucion: string;
    total: number;
}

export interface PagoNominaPreviredFila {
    mes: number;
    nombreMes: string;
    nominas: string;
    instituciones: InstitucionPrevired[];
}

export interface ReportePagosNominasPreviredParseado {
    rut: string;
    razonSocial: string;
    anio: number;
    generadoEn: string;
    pagosNominas: PagoNominaPreviredFila[];
}

export interface InstitucionCasaParticular {
    institucion: string;
    total: number;
}

export interface TrabajadorCasaParticular {
    mes: string;
    nombre: string;
    rut: string;
    plantillas: InstitucionCasaParticular[];
}

export interface ReporteTrabajadorCasaParticularParseado {
    rut: string;
    anio: number;
    cantidadRegistros: number;
    generadoEn: string;
    registros: TrabajadorCasaParticular[];
}

export function parsearPagosNominasPrevired(dto: ReportePagosNominasPreviredDto): ReportePagosNominasPreviredParseado {
    return {
        rut: dto.rutEmpresa,
        razonSocial: dto.razonSocial,
        anio: dto.anio,
        generadoEn: dto.generadoEn,

        pagosNominas: dto.meses.map((mes) => {
            const totalesPorInstitucion = new Map<string, number>();

            for (const nomina of mes.nominas) {
                for (const cotizacion of nomina.cotizaciones) {
                    const actual = totalesPorInstitucion.get(cotizacion.tipoCotizacion) ?? 0;

                    totalesPorInstitucion.set(cotizacion.tipoCotizacion, actual + cotizacion.monto);
                }
            }

            const instituciones = Array.from(totalesPorInstitucion.entries()).map(([institucion, total]) => ({
                institucion,
                total
            }));

            return {
                mes: mes.mes,
                nombreMes: mes.nombreMes,
                nominas: mes.nominas.map((nomina) => nomina.nombre).join(', '),
                instituciones
            };
        })
    };
}


export function parsearTrabajadorCasaParticular(
    dto: TrabajadorCasaParticularDto
): ReporteTrabajadorCasaParticularParseado {
    const registros = Array.isArray(dto.registros) ? dto.registros : [];

    return {
        rut: dto.rutEmpresa,
        anio: dto.anio,
        cantidadRegistros: dto.cantidadRegistros,
        generadoEn: dto.generadoEn,
        registros: registros.map((registro) => {
            const instituciones = Array.isArray(registro.plantillas?.institucion) ? registro.plantillas.institucion : [];
            const totales = Array.isArray(registro.plantillas?.total) ? registro.plantillas.total : [];

            return {
                mes: registro.mes,
                nombre: registro.nombre,
                rut: registro.rut,
                plantillas: instituciones.map((institucion, index) => ({
                    institucion,
                    total: parsearMonto(totales[index])
                }))
            };
        })
    };
}

function parsearMonto(valor: string | undefined): number {
    if (!valor) {
        return 0;
    }

    return Number(
        valor
            .replace('$', '')
            .replace(/\./g, '')
            .replace(/\s/g, '')
    );
}
